<template>
  <div>
    <div class="impersonation-spacer"></div>
    <div class="impersonation-banner">
      <i class="el-icon-warning-outline"></i>
      Você está na conta de <strong>{{ name }}</strong> como administrador. Todas as ações ficam registradas.
      <el-button size="mini" @click="leave">Voltar para minha conta</el-button>
    </div>
  </div>
</template>
<script>
import { leaveImpersonation } from "@/services/auth/storage.services";
import { UserService } from "@/services/users/user.services";

export default {
  name: "ImpersonationBanner",
  data() {
    return {
      name: "",
    };
  },
  methods: {
    leave: leaveImpersonation,
  },
  mounted() {
    UserService.me()
      .then((user) => {
        this.name = user.customers ? `${user.name} (${user.customers.name})` : user.name;
      })
      .catch(() => {});
  },
};
</script>
<style scoped>
.impersonation-spacer {
  height: 44px;
}

.impersonation-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  padding: 8px 16px;
  text-align: center;
  background: #e6a23c;
  color: #fff;
}

.impersonation-banner .el-button {
  margin-left: 12px;
}
</style>
